<template>
    <div class="enroll_box no-trans" v-loading="loading">
        <div class="enroll_flex">
            <div class="enroll_lefts">
                <div class="enroll_title">
                    做一个有口碑的<span>法律裁判点评网</span>
                </div>
                <div class="enroll_text">
                    全面支持法律服务在线下单，金牌云律师智库在线查询海量合同模板免费下载，各类法律资讯实时推送聚焦社会热点问题，让法律服务更加融入我们的生活全面支持法律服务在线下单，金牌云律师智库在线查询海量合同模板免费下载，各类法律资讯实时推送聚焦社会热点问题，让法律服务更加融入我们的生活
                </div>
            </div>
            <div class="enroll_rights">
                <div class="titles">会员注册</div>
                <div class="type_box">
                    <div class="type_check" :class="{type_check_ac:type_check_ac==1}" @click="type_check_ac=1">
                        <div class="texts">个人会员</div>
                        <div class="borders"></div>
                    </div>
                    <div class="type_check" :class="{type_check_ac:type_check_ac==2}" @click="type_check_ac=2">
                        <div class="texts">企业会员</div>
                        <div class="borders"></div>
                    </div>
                </div>
                <div class="form_box">
                    <div class="input_box">
                        <div class="texts">手机号</div>
                        <div class="borders"></div>
                        <div class="inputs">
                            <input type="text" v-model="form.mobile" placeholder="请输入手机号">
                        </div>
                    </div>
                    <div class="input_box">
                        <div class="texts">验证码</div>
                        <div class="borders"></div>
                        <div class="inputs">
                            <input type="text" v-model="form.code" placeholder="请输入验证码">
                        </div>
                        <div class="btns" @click="handle_code">{{ code_title }}</div>
                    </div>
                    <div class="input_box">
                        <div class="texts">密码</div>
                        <div class="borders"></div>
                        <div class="inputs">
                            <input type="password" v-model="form.pwd" placeholder="请输入密码">
                        </div>
                    </div>
                    <div class="input_box">
                        <div class="texts">重复密码</div>
                        <div class="borders"></div>
                        <div class="inputs">
                            <input type="password" v-model="form.pwd2" placeholder="请输入重复密码">
                        </div>
                    </div>
                    <div class="input_box">
                        <div class="texts">邀请码</div>
                        <div class="borders"></div>
                        <div class="inputs">
                            <input type="text" v-model="form.yqm" placeholder="请输入邀请码">
                        </div>
                    </div>
                </div>
                <div class="btns_box">
                    <div class="btns" @click="handle_enroll">立即注册</div>
                </div>
                <div class="agree_box">
                    <el-checkbox v-model="agree_ac"></el-checkbox>
                    &nbsp;&nbsp;我已阅读并同意
                    <span @click="handle_xy">《隐私政策》</span>
                    <span @click="handle_xy2">《客户协议》</span>
                    <span @click="handle_xy3">《第三方个人信息处理规则》</span>
                </div>
                <div class="border_box"></div>
                <div class="login_box">
                    已有账号，<span @click="handle_logo">去登录</span>
                </div>
            </div>
        </div>        
        <agreement ref="agreement" @handle_end="handle_end"></agreement>
        <enroll_success ref="enroll_success"></enroll_success>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
import enroll_success from '@/components/login/enroll_success.vue'
export default {
    components: {
        enroll_success,
    },
    name: "homes",
    data() {
        return {
            loading:false,
            agree_ac:false,
            type_check_ac:1,//1个人 2企业
            code_title:'发送验证码',
            code_time:60,
            timer:null,
            code_show:true,
            form:{
                // type:'',//
                mobile:'15231207781',//手机号
                code:'',//验证码
                pwd:'',//密码
                pwd2:'',//重复密码
                yqm:'',//邀请码
            },
        }
    },
    computed: {
       
    },
    watch: {

    },
    created() {
        if(this.$route.query.code){
            this.form.yqm=this.$route.query.code
        }
    },
    mounted(){
        this.$refs.agreement.handle_open()

    },
    methods: {
        handle_xy(){
            this.$refs.agreement.handle_open()
        },
        handle_xy2(){
            this.$refs.agreement.handle_open('customer_agreement')
        },
        handle_xy3(){
            this.$refs.agreement.handle_open('personal_rule')
        },
        handle_end(){
            this.agree_ac=true
        },
        handle_logo(){
            this.$router.push({
                path:'/login'
            })
        },
        handle_code(){
            if(!this.form.mobile){
                alertErr('请输入手机号')
                return
            }
            if(!this.code_show){
                return
            }
            let reg = /^((11[0-9])|(12[0-9])|(13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/;
            if (!reg.test(this.form.mobile)) {
                alertErr('请输入正确的手机号')
                return 
            }
            this.$api("send", {
				mobile:this.form.mobile
			}, "get").then((res) => {
                this.loading = false
                console.log('注册',res)


                this.code_show=false
                this.code_title=this.code_time+'s'
                this.timer=setInterval(() => {
                    if(this.code_time==0){
                        this.code_time=60
                        this.code_show=true
                        this.code_title='重新发送'
                        clearInterval(this.timer)
                    }else{
                        this.code_time=this.code_time-1
                        this.code_title=this.code_time+'s'
                    }
                }, 1000);


                if (res.code == 1) {
                    alertSucc('发送成功')
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_enroll(){
            if(!this.agree_ac){
                alertErr('请阅读隐私协议')
                return
            }
            if(!this.form.mobile){
                alertErr('请输入手机号')
                return
            }
            let reg = /^((11[0-9])|(12[0-9])|(13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/;
            if (!reg.test(this.form.mobile)) {
                alertErr('请输入正确的手机号')
                return 
            }
            if(!this.form.code){
                alertErr('请输入验证码')
                return
            }
            if(!this.form.pwd){
                alertErr('请输入密码')
                return
            }
            if(!this.form.pwd2){
                alertErr('请输入重复密码')
                return
            }
            if(this.form.pwd!=this.form.pwd2){
                alertErr('两次密码不一致')
                return
            }
            this.$api("register", {
				...this.form,
                log_type:this.type_check_ac,
			}, "get").then((res) => {
                this.loading = false
                console.log('注册',res)
                if (res.code == 1) {
                    this.$refs.enroll_success.handle_open()
                } else {
                    alertErr(res.msg)
                }
            });




        },



    },

}
</script>
<style scoped lang="less">
.enroll_box {
    width: 100%;
    height: 783px;
    background-image: url('../../assets/img/login/login_bg.png');

    background-size:100% 100%;
    .enroll_flex{
        width: 1440px;
        height: 100%;
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .enroll_lefts{
            .enroll_title{
                font-family: HGJZY, HGJZY;
                font-weight: 400;
                font-size: 48px;
                color: #222222;
                padding-bottom: 63px;
                span{
                    color: #377CFD;
                }

            }
            .enroll_text{
                width: 608px;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 16px;
                color: #666666;
                line-height: 48px;
            }
        }
        .enroll_rights{
            width: 480px;
            height: 673px;
            background: #FFFFFF;
            box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);
            border-radius: 12px 12px 12px 12px;
            padding: 32px 40px 25px 40px;
            .titles{
                text-align: center;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: bold;
                font-size: 20px;
                color: #333333;
            }
            .type_box{
                display: flex;
                align-items: center;
                justify-content: space-evenly;
                .type_check{
                    padding-top: 36px;
                    cursor: pointer;
                    .texts{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 18px;
                        color: #666666;
                    }
                    .borders{
                        width: 32px;
                        height: 4px;
                        background: #FFFFFF;

                        border-radius: 4px 4px 4px 4px; 
                        margin: auto;
                        margin-top: 10px;
                    }
                    &:hover{
                        .texts{
                            color: #377CFD;
                        }
                        .borders{
                            background: #377CFD;
                        }  
                    }

                }
                .type_check_ac{
                    .texts{
                        color: #377CFD;
                    }
                    .borders{
                        background: #377CFD;
                    }   
                }
            }
            .form_box{
                padding-top: 30px;
                .input_box{
                    width: 400px;
                    height: 40px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #EEEEEE;
                    display:flex ;
                    align-items: center;
                    margin-bottom: 20px;
                    .texts{
                        font-weight: 400;
                        font-size: 14px;
                        color: #7D7D7D;
                        // padding: 0 24px;
                        width: 90px;
                        flex-shrink: 0;
                        text-align: center;
                    }
                    .borders{
                        width: 1px;
                        height: 18px;
                        background: #EEEEEE;
                        border-radius: 0px 0px 0px 0px;
                    }
                    .inputs{
                        flex: 1;
                        padding: 0 17px;
                        font-size: 14px;
                        input{
                            width: 100%;
                        }
                    }
                    .btns{
                        cursor: pointer;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #377CFD;
                        padding-right:16px;
                    }
                }
            }
            .btns_box{
                padding-top: 40px;
                .btns{
                    width: 400px;
                    height: 44px;
                    background: #377CFD;
                    border-radius: 4px 4px 4px 4px;
                    cursor: pointer;
                    line-height: 44px;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 18px;
                    color: #FFFFFF;
                    text-align: center;
                }
            }
            .agree_box{
                padding-top: 14px;
                display: flex;
                align-items: center;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 12px;
                color: #999999;
                text-wrap: nowrap;
                span{
                    color: #377CFD;
                    cursor: pointer;
                }
            }
            .border_box{
                width: 400px;
                height: 1px;
                background: #E5E5E5;
                border-radius: 0px 0px 0px 0px;
                margin-top: 30px;
            }
            .login_box{
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #666666;
                text-align: center;
                padding-top: 15px;
                span{
                    color: #377CFD;
                    cursor: pointer;
                }
            }
        }
    }
}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .enroll_box.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
        min-height: 0;
        height: auto;
    }
    .enroll_box.no-trans .enroll_flex {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
        flex-wrap: wrap;
        gap: 8px;
    }
    .enroll_box.no-trans .enroll_flex .enroll_lefts .enroll_title {
        font-size: 24px;
        padding-bottom: 16px;
    }
    .enroll_box.no-trans .enroll_flex .enroll_lefts .enroll_text {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        font-size: 16px;
        line-height: 1.6;
    }
    .enroll_box.no-trans .enroll_flex .enroll_rights {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        border-radius: 8px 8px 8px 8px;
        padding: 16px 16px 16px 16px;
    }
    .enroll_box.no-trans .enroll_flex .enroll_rights .titles {
        font-size: 20px;
    }
    .enroll_box.no-trans .enroll_flex .enroll_rights .type_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .enroll_box.no-trans .enroll_flex .enroll_rights .type_box .type_check {
        padding-top: 12px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-bottom: 12px;
    }
    .enroll_box.no-trans .enroll_flex .enroll_rights .type_box .type_check .texts {
        font-size: 18px;
    }
    .enroll_box.no-trans .enroll_flex .enroll_rights .type_box .type_check .borders {
        width: 32px;
        height: 4px;
        border-radius: 4px 4px 4px 4px;
        margin: auto;
        margin-top: 10px;
    }
    .enroll_box.no-trans .enroll_flex .enroll_rights .form_box {
        padding-top: 16px;
    }
    .enroll_box.no-trans .enroll_flex .enroll_rights .form_box .input_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        flex-wrap: wrap;
        gap: 8px;
        margin-bottom: 16px;
        min-height: 40px;
    }
    .enroll_box.no-trans .enroll_flex .enroll_rights .form_box .input_box .texts {
        font-size: 14px;
        width: 90px;
    }
    .enroll_box.no-trans .enroll_flex .enroll_rights .form_box .input_box .borders {
        width: 1px;
        height: 18px;
        border-radius: 0px 0px 0px 0px;
    }
    .enroll_box.no-trans .enroll_flex .enroll_rights .form_box .input_box .inputs {
        padding: 0 16px;
        font-size: 14px;
    }
    .enroll_box.no-trans .enroll_flex .enroll_rights .form_box .input_box .btns {
        font-size: 14px;
        padding-right: 16px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .enroll_box.no-trans .enroll_flex .enroll_rights .btns_box {
        padding-top: 16px;
    }
    .enroll_box.no-trans .enroll_flex .enroll_rights .btns_box .btns {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        font-size: 18px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .enroll_box.no-trans .enroll_flex .enroll_rights .agree_box {
        padding-top: 14px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
        text-wrap: wrap;
        white-space: normal;
        overflow-wrap: anywhere;
    }
    .enroll_box.no-trans .enroll_flex .enroll_rights .border_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 1px;
        border-radius: 0px 0px 0px 0px;
        margin-top: 16px;
    }
    .enroll_box.no-trans .enroll_flex .enroll_rights .login_box {
        font-size: 14px;
        padding-top: 15px;
    }
}
@media (max-width: 1024px) {
    .enroll_box.no-trans {
        padding: 24px 20px; background: #f3f6fb;
        .enroll_flex { flex-direction: column; gap: 24px; }
        .enroll_flex .enroll_lefts { width: 100%; max-width: 480px; padding: 0; }
        .enroll_flex .enroll_lefts .enroll_title { font-size: 22px; line-height: 1.5; }
        .enroll_flex .enroll_lefts .enroll_text { display: none; }
        .enroll_flex .enroll_rights { width: 100%; max-width: 480px; padding: 24px 20px; }
        .enroll_flex .enroll_rights .form_box .input_box { min-height: 48px; height: auto; flex-wrap: nowrap; gap: 0; }
        .enroll_flex .enroll_rights .form_box .input_box .texts { width: 70px; flex-shrink: 0; }
        .enroll_flex .enroll_rights .form_box .input_box .inputs { min-width: 0; padding: 0 8px; }
        .enroll_flex .enroll_rights .form_box .input_box .inputs input { width: 100%; height: 44px; }
        .enroll_flex .enroll_rights .form_box .input_box .btns { flex-shrink: 0; width: auto; max-width: 96px; padding: 8px; font-size: 13px; }
        .enroll_flex .enroll_rights .agree_box { display: block; text-wrap: wrap; line-height: 1.8; }
        .enroll_flex .enroll_rights .agree_box span { text-wrap: wrap; }
    }
}
</style>
